export function GlowOrb({ className = "", color = "primary", size = 500 }) {
  const colorMap = {
    primary: "hsl(var(--primary) / 0.35)",
    secondary: "hsl(var(--secondary) / 0.32)",
    accent: "hsl(265 89% 60% / 0.32)",
  };
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute rounded-full blur-[120px] ${className}`}
      style={{ width: size, height: size, background: colorMap[color] || colorMap.primary }}
    />
  );
}
